import {Pipe, PipeTransform} from '@angular/core';
import {tipo_conta} from "../../../utils/constants.utils";

@Pipe({
  name: 'accountTypeLabel'
})
export class AccountTypeLabelPipe implements PipeTransform {

  transform(value: string): string {
    const found = tipo_conta.find(item => item.optValue === value);
    return found ? found.optLabel : value;
  }

}
